import { takeLatest, put, call, all } from "redux-saga/effects";
import {
  getMain,
  getFeatures,
  getFaqs,
  getUserGuide,
  getRegStep,
  getFaqItems,
} from "network/services/dxpLandingPage";
import type { ISaga } from "../types";

import { getDXPLandingSuccess, getDXPLandingFailed } from "../actionCreators";

function* processGetDXPPage(): ISaga {
  try {
    const { data } = yield call(getMain);

    const { data: newFeatures } = yield call(getFeatures, data[0].new_features);

    const { data: other_features } = yield call(
      getFeatures,
      data[0].other_features
    );

    const { data: faqList } = yield call(getFaqs, data[0].faq_lists);

    if (faqList) {
      yield all(
        faqList.map(function* (item) {
          const itemIds = item.questions_list;
          const { data: questions } = yield call(getFaqItems, itemIds);
          item.questions_list = questions;
        })
      );
    }

    const { data: userGuideList } = yield call(
      getUserGuide,
      data[0].user_guide_lists
    );

    const { data: regSteps } = yield call(
      getRegStep,
      data[0].exist_customer_steps
    );

    const { data: new_customer_steps } = yield call(
      getRegStep,
      data[0].new_customer_steps
    );

    const payload = {
      ...data[0],
      new_features: newFeatures,
      // faq_lists: faqList,
      faq_lists: faqList,
      user_guide_lists: userGuideList,
      other_features,
      exist_customer_steps: regSteps,
      new_customer_steps,
    };

    yield put(getDXPLandingSuccess(payload));
  } catch (e) {
    console.error("GETTING DXP FAILED", e);
    put(getDXPLandingFailed());
  }
}

export default function* watcher() {
  yield takeLatest("REQUEST_DXP_LANDING_DATA", processGetDXPPage);
}
